<template>
  <div class="c-app page" :class="{ 'c-dark-theme': darkMode }">
    
    <Sidebar />
    <CWrapper>
      <Header />
        <div class="c-body">
            <main class="c-main p-0 position-relative">
                <transition name="fade">
                    <CElementCover
                        class="layout__loader"
                        :boundaries="[{ sides: ['top', 'left'], query: '.media-body' }]"
                        :opacity="1"
                        v-show="pageLoadingStore"
                    >
                        <CSpinner 
                            size="5xl" 
                            color="primary"
                            :style="{
                                width: '3rem',
                                height: '3rem'

                            }"
                        />
                    </CElementCover>
                </transition>
                <child/>
            </main>
        </div>
      <Footer />
    </CWrapper>
  </div>
</template>

<script>
import Sidebar from "£lement/sidebar";
import Header from "£lement/header";
import Footer from "£lement/footer";
import { mapGetters } from "vuex";
import Swal from "sweetalert2";
export default {
    name: "MainLayout",

    components: {
        Sidebar,
        Header,
        Footer,
    },

    computed: {
        ...mapGetters({
            darkMode: "panel/darkMode",
            check_commercial:"auth/check_commercial",
            pageLoadingStore: "page/loading",
            storeLangLocale: "lang/locale",
        })
    },
    data () {
        return {
            fixedToasts: 0,
        }
    },
    watch:{
        storeLangLocale(newValue, oldValue){
            if(newValue != oldValue){
                this.$i18n.locale = newValue;
            }
        }
    },
    async mounted(){
        if(!this.check_commercial){
            try {
                let result = await Swal.fire({
                    title: this.$t('verification_required'),
                    text: this.$t("you_need_the_verification_of_a_commercial"),
                    icon: 'warning',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: this.$t('back'),
                    showCancelButton: false,
                    allowOutsideClick: false,
                    allowEscapeKey: false
                })
                if(result.isConfirmed){
                    this.$router.push({name:'welcome'})
                }
            } catch (e) {
                console.log(e);
            }
        }
            
    }
};
</script>
<style scoped lang="scss">
    .container-fluid{
        padding: 0;
    }
</style>
